import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { REACT_APP_API_URL } from '../../../../../../env';

const EditFacilities = ({ isOpen, facilityId, onClose, onUpdated }) => {
  const [facility, setFacility] = useState({ FacilityTitle: '', FacilityDescription: '' });
  const [loading, setLoading] = useState(true); // <-- New loading state

  useEffect(() => {
    if (!isOpen || !facilityId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${REACT_APP_API_URL}api/facilities/get-facility/${facilityId}`);
        if (res.data.data) {
          setFacility(res.data.data);
        }
      } catch (err) {
        console.error('Failed to fetch facility data', err);
      }
      setLoading(false);
    };

    fetchData();
  }, [isOpen, facilityId]);

  const handleChange = (e) => {
    setFacility({ ...facility, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await axios.put(`${REACT_APP_API_URL}api/facilities/update-facility/${facilityId}`, facility);
      
      onUpdated();
      onClose();
    } catch (err) {
      console.error('Failed to update facility', err);
      alert('Failed to update facility. Please try again.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Room Facility</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {loading ? (
              <div>Loading...</div>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label">Facility Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="FacilityTitle"
                    value={facility.FacilityTitle}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Facility Description</label>
                  <input
                    type="text"
                    className="form-control"
                    name="FacilityDescription"
                    value={facility.FacilityDescription}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button onClick={onClose} className="btn btn-secondary">Close</button>
            <button onClick={handleSubmit} className="btn btn-primary" disabled={loading}>Update changes</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFacilities;
